import React from 'react';

import { cn } from '../../lib/utils';

export function AuthHeader({ title }) {
  return <h1 className="w-full text-center text-2xl leading-6 font-semibold tracking-normal text-black">{title}</h1>;
}

export function AuthPageStack({ children }) {
  return <div className="flex w-full flex-col items-center gap-12">{children}</div>;
}

export function AuthHeaderBlock({ children, title }) {
  return (
    <div className="flex w-full flex-col items-center gap-6">
      <AuthHeader title={title} />
      <p className="w-full text-center text-[13px] leading-5 font-medium text-gray-500">{children}</p>
    </div>
  );
}

export function AuthFormMessage({ error, id, message }) {
  if (!error && !message) return null;

  return (
    <p
      id={id}
      className={`w-full px-1 text-sm leading-5 font-medium ${error ? 'text-red-500' : 'text-green-700'}`}
      role={error ? 'alert' : 'status'}
    >
      {error || message}
    </p>
  );
}

export function AuthBackLink({ className, disabled, label, onClick }) {
  if (!label) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'w-full cursor-pointer text-center text-[13px] leading-4 text-gray-500 underline underline-offset-2 hover:text-gray-700 disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      data-app-region="none"
    >
      {label}
    </button>
  );
}
